import React from 'react';
import {TitleTag} from './style';

export default function Title ({children, style}) {
  return (
    <TitleTag style={style}>{ children }</TitleTag>
  )
}
